// source: pbtypes/vehicle/skills/actions/init_global_map/init_global_map.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_body_gps_origin_pb = require('../../../../../pbtypes/gen/body/gps_origin_pb.js');
goog.object.extend(proto, pbtypes_gen_body_gps_origin_pb);
goog.exportSymbol('proto.skills.InitGlobalMapActionArgs', null, global);
goog.exportSymbol('proto.skills.InitGlobalMapActionStateData', null, global);
goog.exportSymbol('proto.skills.InitGlobalMapFromGpsArgs', null, global);
goog.exportSymbol('proto.skills.InitGlobalMapResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.InitGlobalMapFromGpsArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.InitGlobalMapFromGpsArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.InitGlobalMapFromGpsArgs.displayName = 'proto.skills.InitGlobalMapFromGpsArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.InitGlobalMapActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.InitGlobalMapActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.InitGlobalMapActionArgs.displayName = 'proto.skills.InitGlobalMapActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.InitGlobalMapResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.InitGlobalMapResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.InitGlobalMapResultData.displayName = 'proto.skills.InitGlobalMapResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.InitGlobalMapActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.InitGlobalMapActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.InitGlobalMapActionStateData.displayName = 'proto.skills.InitGlobalMapActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.InitGlobalMapFromGpsArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.InitGlobalMapFromGpsArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.InitGlobalMapFromGpsArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapFromGpsArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
globalMapGpsOrigin: (f = msg.getGlobalMapGpsOrigin()) && pbtypes_gen_body_gps_origin_pb.GpsOrigin.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.InitGlobalMapFromGpsArgs}
 */
proto.skills.InitGlobalMapFromGpsArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.InitGlobalMapFromGpsArgs;
  return proto.skills.InitGlobalMapFromGpsArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.InitGlobalMapFromGpsArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.InitGlobalMapFromGpsArgs}
 */
proto.skills.InitGlobalMapFromGpsArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_body_gps_origin_pb.GpsOrigin;
      reader.readMessage(value,pbtypes_gen_body_gps_origin_pb.GpsOrigin.deserializeBinaryFromReader);
      msg.setGlobalMapGpsOrigin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.InitGlobalMapFromGpsArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.InitGlobalMapFromGpsArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.InitGlobalMapFromGpsArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapFromGpsArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGlobalMapGpsOrigin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_body_gps_origin_pb.GpsOrigin.serializeBinaryToWriter
    );
  }
};


/**
 * optional body.GpsOrigin global_map_gps_origin = 1;
 * @return {?proto.body.GpsOrigin}
 */
proto.skills.InitGlobalMapFromGpsArgs.prototype.getGlobalMapGpsOrigin = function() {
  return /** @type{?proto.body.GpsOrigin} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_body_gps_origin_pb.GpsOrigin, 1));
};


/**
 * @param {?proto.body.GpsOrigin|undefined} value
 * @return {!proto.skills.InitGlobalMapFromGpsArgs} returns this
*/
proto.skills.InitGlobalMapFromGpsArgs.prototype.setGlobalMapGpsOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.InitGlobalMapFromGpsArgs} returns this
 */
proto.skills.InitGlobalMapFromGpsArgs.prototype.clearGlobalMapGpsOrigin = function() {
  return this.setGlobalMapGpsOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.InitGlobalMapFromGpsArgs.prototype.hasGlobalMapGpsOrigin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.InitGlobalMapActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.InitGlobalMapActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.InitGlobalMapActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
useGps: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
initFromGpsArgs: (f = msg.getInitFromGpsArgs()) && proto.skills.InitGlobalMapFromGpsArgs.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.InitGlobalMapActionArgs}
 */
proto.skills.InitGlobalMapActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.InitGlobalMapActionArgs;
  return proto.skills.InitGlobalMapActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.InitGlobalMapActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.InitGlobalMapActionArgs}
 */
proto.skills.InitGlobalMapActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseGps(value);
      break;
    case 2:
      var value = new proto.skills.InitGlobalMapFromGpsArgs;
      reader.readMessage(value,proto.skills.InitGlobalMapFromGpsArgs.deserializeBinaryFromReader);
      msg.setInitFromGpsArgs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.InitGlobalMapActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.InitGlobalMapActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.InitGlobalMapActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUseGps();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getInitFromGpsArgs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skills.InitGlobalMapFromGpsArgs.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool use_gps = 1;
 * @return {boolean}
 */
proto.skills.InitGlobalMapActionArgs.prototype.getUseGps = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.InitGlobalMapActionArgs} returns this
 */
proto.skills.InitGlobalMapActionArgs.prototype.setUseGps = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional InitGlobalMapFromGpsArgs init_from_gps_args = 2;
 * @return {?proto.skills.InitGlobalMapFromGpsArgs}
 */
proto.skills.InitGlobalMapActionArgs.prototype.getInitFromGpsArgs = function() {
  return /** @type{?proto.skills.InitGlobalMapFromGpsArgs} */ (
    jspb.Message.getWrapperField(this, proto.skills.InitGlobalMapFromGpsArgs, 2));
};


/**
 * @param {?proto.skills.InitGlobalMapFromGpsArgs|undefined} value
 * @return {!proto.skills.InitGlobalMapActionArgs} returns this
*/
proto.skills.InitGlobalMapActionArgs.prototype.setInitFromGpsArgs = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.InitGlobalMapActionArgs} returns this
 */
proto.skills.InitGlobalMapActionArgs.prototype.clearInitFromGpsArgs = function() {
  return this.setInitFromGpsArgs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.InitGlobalMapActionArgs.prototype.hasInitFromGpsArgs = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.InitGlobalMapResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.InitGlobalMapResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.InitGlobalMapResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.InitGlobalMapResultData}
 */
proto.skills.InitGlobalMapResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.InitGlobalMapResultData;
  return proto.skills.InitGlobalMapResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.InitGlobalMapResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.InitGlobalMapResultData}
 */
proto.skills.InitGlobalMapResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.InitGlobalMapResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.InitGlobalMapResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.InitGlobalMapResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.InitGlobalMapActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.InitGlobalMapActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.InitGlobalMapActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.InitGlobalMapActionStateData}
 */
proto.skills.InitGlobalMapActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.InitGlobalMapActionStateData;
  return proto.skills.InitGlobalMapActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.InitGlobalMapActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.InitGlobalMapActionStateData}
 */
proto.skills.InitGlobalMapActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.InitGlobalMapActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.InitGlobalMapActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.InitGlobalMapActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.InitGlobalMapActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
